export const updateShowButtons = (number) => (dispatch, getState) => {
  if (getState().coffee.home.showButtons === number) {
    dispatch({
      type: 'SHOW_COFFEE_BUTTONS',
      payload: 0
    });
  } else {
    dispatch({
      type: 'SHOW_COFFEE_BUTTONS',
      payload: number
    });
  }
};
